import { CSRF_PATH } from '@/config';
import { axios } from '@/lib/axios';

export const getCsrfToken = async () => axios.get(CSRF_PATH);
